export const formatNumber = (number: number) =>
  number.toLocaleString(undefined);
